function removeItem(key) {
    const button = event.currentTarget;
    button.classList.add('is-loading');
    button.disabled = true;

    theme.cart.changeItem(key, 0)
        .then(response => {
            const parsedCart = JSON.parse(response);

            // Trigger cart drawer rebuild
            if (theme.CartDrawer) {
                document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            }

            // Update sticky cart if it exists
            if (theme.settings.cartType === 'sticky' && theme.StickyCart) {
                theme.cart.getCart().then(function(cart) {
                    theme.StickyCart.refresh(cart);
                });
            }

            // Update cart status and bubbles
            if (parsedCart.item_count === 0) {
                document.body.classList.remove('cart-has-items');
            }

            const bubbles = document.querySelectorAll('.cart-link__bubble');
            const countEls = document.querySelectorAll('.cart-link__bubble-num');

            if (countEls.length) {
                countEls.forEach(el => {
                    el.innerText = parsedCart.item_count;
                });
            }

            if (bubbles.length) {
                if (parsedCart.item_count > 0) {
                    bubbles.forEach(b => {
                        b.classList.add('cart-link__bubble--visible');
                    });
                } else {
                    bubbles.forEach(b => {
                        b.classList.remove('cart-link__bubble--visible');
                    });
                }
            }

            // Reset button state
            button.classList.remove('is-loading');
            button.disabled = false;
        })
        .catch(error => {
            console.error('Error:', error);
            button.classList.remove('is-loading');
            button.disabled = false;
            alert('Error removing item from cart');
        });
}